import Vue from 'vue';
import store from '@/store';
import Vuetify from 'vuetify/lib/framework';
import it from 'vuetify/lib/locale/it';
import pl from 'vuetify/lib/locale/pl';
import en from 'vuetify/lib/locale/en';
import fr from 'vuetify/lib/locale/fr';
import de from 'vuetify/lib/locale/de';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: colors.red,
        secondary: colors.grey.darken1,
        accent: colors.shades.black,
        error: colors.red.accent3,
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
      dark: {
        primary: colors.blue.lighten3
      }
    }
  },
  lang: {
    locales: { it, en, pl, fr, de },
    current: store.getters['locale/locale']
  },
  breakpoint: {
    thresholds: {
      xs: 420,  // default: 600
      sm: 600,  // default: 960
      md: 1120, // default: 1264
      lg: 1740  // default: 1904
    },
    scrollBarWidth: 16 // default: 16
  }
});
